import React, { useState } from 'react';

function Blog() {
  return (
    <div>
      <h2></h2>
    </div>
  )
}

export default Blog;